import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { WorkflowConfigurationService } from "../services/workflowconfiguration.service";
import { Observable } from "rxjs";
import { ICountryWorkflowConfigurationStatus } from "../interfaces/icountryworkflowconfigurationstatus";

@Injectable()
export class WorkflowCountriesResolver implements Resolve<ICountryWorkflowConfigurationStatus[]> {
    constructor(private workflowConfigurationService: WorkflowConfigurationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ICountryWorkflowConfigurationStatus[]> {
        return this.workflowConfigurationService.getCountryWorkflowConfigurationStatus();
    }
}
